var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdEnlaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269.406,
    height: 220,
    viewBox: "0 0 269.406 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58176",
    "data-name": "Grupo 58176",
    transform: "translate(-1004.212 -435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2077",
    "data-name": "Grupo 2077",
    transform: "translate(1004.212 435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3417",
    "data-name": "Trazado 3417",
    d: "M77.782,0A77.782,77.782,0,1,1,0,77.782,77.782,77.782,0,0,1,77.782,0Z",
    transform: "translate(0 110) rotate(-45)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_44",
    "data-name": "Elipse 44",
    cx: 72.323,
    cy: 72.323,
    r: 72.323,
    transform: "translate(7.719 110) rotate(-45)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("g", {
    id: "link_24dp",
    transform: "translate(42.5 41.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25600",
    "data-name": "Trazado 25600",
    d: "M0,0H142V142H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25601",
    "data-name": "Trazado 25601",
    d: "M90.75,7H67.083V18.833H90.75a17.75,17.75,0,0,1,0,35.5H67.083V66.167H90.75A29.583,29.583,0,0,0,90.75,7ZM55.25,54.333H31.583a17.75,17.75,0,0,1,0-35.5H55.25V7H31.583a29.583,29.583,0,0,0,0,59.167H55.25ZM37.5,30.667H84.833V42.5H37.5Z",
    transform: "translate(9.833 34.417)",
    fill: "#db2491"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31655",
    "data-name": "Grupo 31655",
    transform: "translate(1175.618 540.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2405",
    "data-name": "Trazado 2405",
    d: "M1900.88,694.713a49,49,0,1,0,49,49A49.055,49.055,0,0,0,1900.88,694.713Z",
    transform: "translate(-1851.877 -694.713)",
    fill: "#77c200"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1906",
    "data-name": "Grupo 1906",
    transform: "translate(24.127 28.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2406",
    "data-name": "Trazado 2406",
    d: "M1948.74,762.286l-29.388,29.388a5.522,5.522,0,0,1-3.9,1.614,4.709,4.709,0,0,1-.635-.035,5.508,5.508,0,0,1-4.055-2.571l-9.311-15.015a5.515,5.515,0,0,1,9.373-5.814l5.649,9.1,24.469-24.464a5.516,5.516,0,1,1,7.8,7.8Z",
    transform: "translate(-1900.615 -752.872)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdEnlaces);
export default __webpack_public_path__ + "static/media/ID_enlaces.bd2cbb7b4adf3fc2e48be6851e19ac2b.svg";
export { ForwardRef as ReactComponent };